import { CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { LoaderWrapper, LoaderCover, Label } from './Loader.styles';
var Loader = function (props) {
    var type = props.type, label = props.label;
    var renderLabel = function () {
        return label ? (React.createElement(Label, null,
            React.createElement(Typography, null, label))) : null;
    };
    var renderWrapper = function (spinner) {
        if (type === 'inline') {
            return (React.createElement(LoaderWrapper, null,
                spinner,
                renderLabel()));
        }
        return (React.createElement(LoaderCover, null,
            spinner,
            renderLabel()));
    };
    return renderWrapper(React.createElement(CircularProgress, { color: "primary" }));
};
export default Loader;
